import React from "react";
import { useTranslation } from "react-i18next";

import CustomModal from "../";

export default function Prompt({
  visible,
  title,
  description,
  handleConfirm,
  handleCancel,
  textCancel,
  textConfirm,
}) {
  const { t } = useTranslation();

  if (!textCancel) {
    textCancel = t("no");
  }

  if (!textConfirm) {
    textConfirm = t("yes");
  }

  return (
    <CustomModal visible={visible}>
      <div className="p-3 rounded-[20px] bg-[#36383F] border-[1px] border-[#6A6C71]">
        <h1 className="text-xl font-bold uppercase text-center">{title}</h1>
        <p className="text-center mb-3">{description}</p>
        <hr className="border-[#6A6C71] mb-4"></hr>
        <div className="flex justify-center mb-2">
          <button
            type="button"
            onClick={handleCancel}
            className="btn btn-small bg-[#BD2CAE] touchable-opacity w-full p-1 pt-2 pb-2 me-2"
          >
            <div className="flex items-center justify-center">{textCancel}</div>
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            className="btn btn-small bg-[#CC0056] touchable-opacity w-full p-1 pt-2 pb-2 ms-2"
          >
            {textConfirm}
          </button>
        </div>
      </div>
    </CustomModal>
  );
}
